import qs from 'querystring';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import { Container } from 'reactstrap';
import CheckPublicStatus from './CheckPublicStatus';
import { authUserSelector } from '~redux/auth/selectors/authUser';
import { Brand } from '~redux/brand/types';
import { clearProduct } from '~redux/product/actions';
import { productModelSelector } from '~redux/product/selectors';
import { getProduct } from '~redux/product/thunk';
import { getPublicImageUrl } from '~utils/image';
import { useHeadContent } from '~view/hooks/head';
import { useThunkQueue } from '~view/hooks/thunk';
import BuyerPage from '~view/widgets/BuyerPage';
import InventoryProvider from '~view/widgets/InventoryProvider';
import LoadingContainer from '~view/widgets/LoadingContainer';

type ProductDetailsProps = {};

const ProductDetails: React.FC<ProductDetailsProps> = () => {
  const { id: productId } = useParams<{
    id: string;
  }>();
  const id = productId ? decodeURIComponent(productId) : productId;
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector(authUserSelector);
  const product = useSelector(productModelSelector);
  const is_direct = !!qs.parse(history.location.search?.split('?')?.[1])
    ?.direct;
  const contactId = qs.parse(history.location.search?.split('?')?.[1])
    ?.contactId;

  const { queue, isProcessing } = useThunkQueue('getProduct');
  useEffect(() => {
    queue(getProduct(id, !user));
    return () => {
      dispatch(clearProduct());
    };
  }, [user, id]);

  useHeadContent({
    title: product?.product_name
      ? `${product?.product_name} | ${product.brand?.brand_name || ''}`
      : '',
    description: `${product?.product_content ?? ''}`,
    url: `${process.env.REACT_APP_DOMAIN}/productdetail/${product?.id ?? ''}`,
    image: getPublicImageUrl(product?.imageKeys?.[0]?.imageKey || '', {
      w: 300,
      h: 300,
    }),
    breadcrumbs: [
      {
        text: 'トップ',
        url: process.env.REACT_APP_DOMAIN,
      },
      {
        text: product?.product_name ?? '',
      },
    ],
  });

  if (product?.brand?.is_sale_brand) {
    if (product.collections?.items[0]) {
      return (
        <Redirect to={`/sale/${product.collections.items[0].collection_id}`} />
      );
    }
    return <Redirect to={`/`} />;
  }

  return (
    <BuyerPage
      unAuth
      direct={is_direct}
      directBrand={product?.brand as Brand}
      contactId={contactId as string}
    >
      <InventoryProvider productIds={[id]}>
        <LoadingContainer isLoading={isProcessing}>
          <Container>
            {product && <CheckPublicStatus product={product} />}
          </Container>
        </LoadingContainer>
      </InventoryProvider>
    </BuyerPage>
  );
};

export default ProductDetails;
